/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Ai_AgentsInputs */

const en_footer_ai_agents = /** @type {(inputs: Footer_Ai_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI agents`)
};

const zh_hans1_footer_ai_agents = /** @type {(inputs: Footer_Ai_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 智能体`)
};

const pt_br2_footer_ai_agents = /** @type {(inputs: Footer_Ai_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes de IA`)
};

const es_footer_ai_agents = /** @type {(inputs: Footer_Ai_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes de IA`)
};

const fr_footer_ai_agents = /** @type {(inputs: Footer_Ai_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents IA`)
};

const de_footer_ai_agents = /** @type {(inputs: Footer_Ai_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Agenten`)
};

const ru_footer_ai_agents = /** @type {(inputs: Footer_Ai_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ-агенты`)
};

const it_footer_ai_agents = /** @type {(inputs: Footer_Ai_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenti IA`)
};

/**
* | output |
* | --- |
* | "AI agents" |
*
* @param {Footer_Ai_AgentsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_ai_agents = /** @type {((inputs?: Footer_Ai_AgentsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Ai_AgentsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_ai_agents(inputs)
	if (locale === "pt-BR") return pt_br2_footer_ai_agents(inputs)
	if (locale === "es") return es_footer_ai_agents(inputs)
	if (locale === "fr") return fr_footer_ai_agents(inputs)
	if (locale === "de") return de_footer_ai_agents(inputs)
	if (locale === "ru") return ru_footer_ai_agents(inputs)
	if (locale === "it") return it_footer_ai_agents(inputs)
	return en_footer_ai_agents(inputs)
});